module.exports = __webpack_public_path__ + "static/media/backArrowCarousel.3a1ac0e1.svg";